"use client";

import React, { useState, useRef, useEffect } from "react";
import Image from "next/image";
import {
  LuLayoutGrid, LuActivity, LuRocket, LuBuilding, LuCpu,
  LuGraduationCap, LuTrendingUp, LuShoppingCart, LuCheck,
  LuPlane, LuGem, LuHouse, LuHeart, LuStar, LuZap,
  LuCode, LuGlobe, LuSmartphone, LuCloud, LuBrain,
  LuSettings, LuUsers, LuShield, LuDatabase, LuTarget,
  LuVideo, LuTruck, LuBanknote, LuCoffee, LuCar, LuTrophy,
  LuWallet, LuCreditCard, LuHardHat, LuDroplet, LuBookOpen, LuCoins
} from "react-icons/lu";

const LuIconsMap = {
  LuLayoutGrid, LuActivity, LuRocket, LuBuilding, LuCpu,
  LuGraduationCap, LuTrendingUp, LuShoppingCart, LuCheck,
  LuPlane, LuGem, LuHouse, LuHeart, LuStar, LuZap,
  LuCode, LuGlobe, LuSmartphone, LuCloud, LuBrain,
  LuSettings, LuUsers, LuShield, LuDatabase, LuTarget,
  LuVideo, LuTruck, LuBanknote, LuCoffee, LuCar, LuTrophy,
  LuWallet, LuCreditCard, LuHardHat, LuDroplet, LuBookOpen, LuCoins
};
import "./IndustriesWeServe.css";


const ADMIN_TECH_PRESETS = [
  { name: "Java", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/java/java-original.svg" },
  { name: "Spring", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/spring/spring-original.svg" },
  { name: "Spring Boot", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/spring/spring-original.svg" },
  { name: "Python", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/python/python-original.svg" },
  { name: "Django", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/django/django-plain.svg" },
  { name: "Flask", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/flask/flask-original.svg" },
  { name: "FastAPI", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/fastapi/fastapi-original.svg" },
  { name: "C#", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/csharp/csharp-original.svg" },
  { name: "ASP.NET Core", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/dotnetcore/dotnetcore-original.svg" },
  { name: "PHP", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/php/php-original.svg" },
  { name: "Laravel", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/laravel/laravel-original.svg" },
  { name: "Symfony", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/symfony/symfony-original.svg" },
  { name: "Go", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/go/go-original.svg" },
  { name: "Ruby on Rails", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/rails/rails-original-wordmark.svg" },
  { name: "C++", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/cplusplus/cplusplus-original.svg" },
  { name: "UE4", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/unrealengine/unrealengine-original.svg" },
  { name: "TensorFlow", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tensorflow/tensorflow-original.svg" },
  { name: "PyTorch", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/pytorch/pytorch-original.svg" },
  { name: "PostgreSQL", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/postgresql/postgresql-original.svg" },
  { name: "Oracle", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/oracle/oracle-original.svg" },
  { name: "MS SQL", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/microsoftsqlserver/microsoftsqlserver-original.svg" },
  { name: "MongoDB", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/mongodb/mongodb-original.svg" },
  { name: "Redis", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/redis/redis-original.svg" },
  { name: "Elasticsearch", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/elasticsearch/elasticsearch-original.svg" },
  { name: "JavaScript", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/javascript/javascript-original.svg" },
  { name: "TypeScript", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/typescript/typescript-original.svg" },
  { name: "React", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg" },
  { name: "Redux", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/redux/redux-original.svg" },
  { name: "Vue.js", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vuejs/vuejs-original.svg" },
  { name: "Angular", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/angularjs/angularjs-original.svg" },
  { name: "Next.js", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nextjs/nextjs-original.svg" },
  { name: "Swift", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/swift/swift-original.svg" },
  { name: "Android", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/android/android-original.svg" },
  { name: "Kotlin", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/kotlin/kotlin-original.svg" },
  { name: "Flutter", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/flutter/flutter-original.svg" },
  { name: "React Native", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg" },
  { name: "Kubernetes", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/kubernetes/kubernetes-original.svg" },
  { name: "Terraform", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/terraform/terraform-original.svg" },
  { name: "Ansible", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/ansible/ansible-original.svg" },
  { name: "Jenkins", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/jenkins/jenkins-original.svg" },
  { name: "Docker", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/docker/docker-original.svg" },
  { name: "Selenium", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/selenium/selenium-original.svg" },
  { name: "Postman", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/postman/postman-original.svg" },
  { name: "GraphQL", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/graphql/graphql-plain.svg" },
  { name: "Git", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/git/git-original.svg" },
  { name: "GitHub", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/github/github-original.svg" },
  { name: "VS Code", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vscode/vscode-original.svg" },
  { name: "Figma", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/figma/figma-original.svg" },
  { name: "Nginx", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nginx/nginx-original.svg" }
];

export default function IndustriesWeServe({ data }) {
  const getImageUrl = (url) => {
    if (!url || typeof url !== "string") return "";
    if (url.startsWith("data:") || url.startsWith("blob:")) return url;

    let finalUrl = url;
    const apiUrl = (process.env.NEXT_PUBLIC_API_URL || process.env.NEXT_PUBLIC_API_BASE_URL || '').replace(/\/api\/?$/, '').replace(/\/$/, '') || "";

    if (url.includes("/uploads/")) {
      const cleanPath = url.substring(url.indexOf("/uploads/"));
      finalUrl = `${apiUrl}${cleanPath}`;
    } else if (url.startsWith("uploads/") || url.startsWith("/uploads/")) {
      const cleanPath = url.startsWith("/") ? url : `/${url}`;
      finalUrl = `${apiUrl}${cleanPath}`;
    } else if (url.startsWith("http")) {
      finalUrl = url;
    }

    if (finalUrl.includes("res.cloudinary.com") && finalUrl.includes("/image/upload/")) {
      if (!finalUrl.includes("f_auto") && !finalUrl.includes("q_auto")) {
        finalUrl = finalUrl.replace("/image/upload/", "/image/upload/f_auto,q_auto/");
      }
    }
    return finalUrl;
  };

  const renderIcon = (iconName, size = 18) => {
    if (!iconName) return <LuLayoutGrid size={size} strokeWidth={2.5} />;

    const iconStr = typeof iconName === 'string' ? iconName : (iconName.url || '');
    if (!iconStr) return <LuLayoutGrid size={size} strokeWidth={2.5} />;

    // 1. Check if it's an image URL or base64/blob
    const isImage = iconStr.startsWith("http") || iconStr.startsWith("/") || iconStr.includes("uploads") || iconStr.includes("blob:");
    if (isImage) {
      return (
        <Image
          src={getImageUrl(iconStr)}
          alt="Icon"
          style={{ objectFit: "contain" }}
          width={size}
          height={size}
          onError={(e) => {
            if (e.currentTarget) e.currentTarget.style.display = 'none';
          }}
        />
      );
    }

    // 2. Check if it's a technology preset logo
    const matchedPreset = ADMIN_TECH_PRESETS.find(p => p.name.toLowerCase() === iconStr.toLowerCase());
    if (matchedPreset) {
      return (
        <Image
          src={matchedPreset.logo}
          alt={matchedPreset.name}
          style={{ objectFit: "contain" }}
          width={size}
          height={size}
        />
      );
    }

    // 3. Check if it's a FontAwesome icon class
    const isFA = iconStr.startsWith("fa-") || iconStr.includes(" ");
    if (isFA) {
      let faClass = iconStr;
      if (!iconStr.startsWith("fa-")) {
        faClass = `fa-solid fa-${iconStr}`;
      }
      return <i className={faClass} style={{ fontSize: size }} />;
    }

    // 4. Default fallback to react-icons/lu
    let key = iconStr;
    if (key && !key.startsWith("Lu")) {
      key = "Lu" + key.charAt(0).toUpperCase() + key.slice(1);
    }
    if (key === "LuHomeIcon" || key === "LuHomeicon" || key === "LuHome") {
      key = "LuHouse";
    }
    const IconComponent = LuIconsMap[key] || LuLayoutGrid;
    return <IconComponent size={size} strokeWidth={2.5} />;
  };

  const industriesList = (data?.industries || []).map((ind, idx) => ({
    id: ind.id || ind._id || `ind-${idx}`,
    originalIndex: idx,
    label: ind.tab?.title || "",
    title: ind.card?.heading || "",
    description: ind.card?.description || "",
    points: (ind.card?.features || []).map(f => ({
      title: f.title,
      icon: f.icon || "Check"
    })),
    iconName: ind.tab?.icon || "Activity",
    image: getImageUrl(ind.card?.image?.url || "")
  }));


  // Track active industry
  const [activeIndustryId, setActiveIndustryId] = useState(null);

  // Inactive list state for the continuous carousel
  const [inactiveList, setInactiveList] = useState([]);

  const viewportRef = useRef(null);
  const animFrameRef = useRef(null);
  const isDraggingRef = useRef(false);
  const startXRef = useRef(0);
  const scrollStartRef = useRef(0);
  const hasMovedRef = useRef(false);
  const isUserInteractingRef = useRef(false);
  const resumeTimerRef = useRef(null);

  // Synchronize when data loads or changes
  useEffect(() => {
    if (industriesList.length > 0) {
      setActiveIndustryId((prevId) => {
        const exists = industriesList.find(i => i.id === prevId);
        const nextId = exists ? exists.id : industriesList[0].id;
        setInactiveList(industriesList.filter(i => i.id !== nextId));
        return nextId;
      });
    }
  }, [JSON.stringify(data?.industries)]);

  const activeData = industriesList.find(i => i.id === activeIndustryId) || industriesList[0];

  // Continuous Train Movement using requestAnimationFrame
  useEffect(() => {
    const el = viewportRef.current;
    if (!el || inactiveList.length <= 1) return;

    const speed = 0.8; // Constant train speed in pixels per frame

    const loop = () => {
      if (!isUserInteractingRef.current && el) {
        el.scrollLeft += speed;
        const half = el.scrollWidth / 2;
        if (half > 0 && el.scrollLeft >= half) {
          el.scrollLeft -= half;
        }
      }
      animFrameRef.current = requestAnimationFrame(loop);
    };

    animFrameRef.current = requestAnimationFrame(loop);
    return () => {
      if (animFrameRef.current) cancelAnimationFrame(animFrameRef.current);
    };
  }, [inactiveList]);

  const pauseInteraction = () => {
    isUserInteractingRef.current = true;
    if (resumeTimerRef.current) clearTimeout(resumeTimerRef.current);
  };

  const resumeInteraction = (delay = 1200) => {
    if (resumeTimerRef.current) clearTimeout(resumeTimerRef.current);
    resumeTimerRef.current = setTimeout(() => {
      isUserInteractingRef.current = false;
    }, delay);
  };

  // Mouse Drag Handlers
  const handleMouseDown = (e) => {
    const el = viewportRef.current;
    if (!el) return;
    isDraggingRef.current = true;
    hasMovedRef.current = false;
    startXRef.current = e.pageX - el.offsetLeft;
    scrollStartRef.current = el.scrollLeft;
    pauseInteraction();
  };

  const handleMouseMove = (e) => {
    if (!isDraggingRef.current) return;
    const el = viewportRef.current;
    if (!el) return;
    e.preventDefault();
    const x = e.pageX - el.offsetLeft;
    const walk = (x - startXRef.current) * 1.4;
    if (Math.abs(walk) > 4) {
      hasMovedRef.current = true;
    }
    el.scrollLeft = scrollStartRef.current - walk;

    const half = el.scrollWidth / 2;
    if (half > 0) {
      if (el.scrollLeft >= half) {
        el.scrollLeft -= half;
        scrollStartRef.current -= half;
      } else if (el.scrollLeft <= 0) {
        el.scrollLeft += half;
        scrollStartRef.current += half;
      }
    }
  };

  const handleMouseUpOrLeave = () => {
    if (isDraggingRef.current) {
      isDraggingRef.current = false;
    }
    resumeInteraction(1200);
  };

  // Touch Swipe Handlers (Fingertip)
  const handleTouchStart = () => {
    hasMovedRef.current = false;
    pauseInteraction();
  };

  const handleTouchMove = () => {
    hasMovedRef.current = true;
    const el = viewportRef.current;
    if (el) {
      const half = el.scrollWidth / 2;
      if (half > 0) {
        if (el.scrollLeft >= half) {
          el.scrollLeft -= half;
        } else if (el.scrollLeft <= 0) {
          el.scrollLeft += half;
        }
      }
    }
  };

  const handleTouchEnd = () => {
    resumeInteraction(1500);
  };

  // Handle click on any inactive tab
  const handleTabClick = (clickedItem) => {
    if (hasMovedRef.current) return; // Ignore clicks if user was dragging/swiping
    if (clickedItem.id === activeIndustryId) return;

    const prevActive = activeData;
    setActiveIndustryId(clickedItem.id);

    setInactiveList(prev => {
      const filtered = prev.filter(item => item.id !== clickedItem.id);
      return prevActive ? [prevActive, ...filtered] : filtered;
    });
  };

  const renderTabButton = (tab, isActive, onClick = null) => (
    <button
      type="button"
      className={`industry-tab-btn ${isActive ? "active" : ""}`}
      onClick={onClick}
      style={{
        flex: "0 0 160px",
        width: "160px",
        minWidth: "160px",
      }}
    >
      <span className="tab-icon-span" style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
        {renderIcon(tab.iconName)}
      </span>
      <span className="tab-label-span">{tab.label}</span>
    </button>
  );

  // Duplicate inactive list for seamless infinite train loop
  const renderInactiveItems = inactiveList.length > 0
    ? [...inactiveList, ...inactiveList, ...inactiveList, ...inactiveList]
    : [];

  return (
    <section className="industries-section py-5">
      <div className="container py-3">
        <div className="text-center mb-5" data-aos="fade-up">
          <div
            className="why-header-home"
            data-aos="fade-up"
            data-aos-delay="0"
          >
            <span>Our Services</span>
            <h2 className="industries-heading-title">{data?.heading || "Industries We Serve"}</h2>
          </div>
        </div>

        {industriesList.length > 0 && (
          <div className="industries-main-card" data-aos="fade-up">
            {/* TABS CONTAINER */}
            <div
              className="industries-tabs-container"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "stretch",
                width: "100%",
                overflow: "hidden",
                borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
                position: "relative",
              }}
            >
              {/* FIXED ACTIVE TAB SLOT */}
              <div
                className="active-tab-slot"
                style={{
                  flex: "0 0 160px",
                  width: "160px",
                  minWidth: "160px",
                  position: "relative",
                  zIndex: 10,
                }}
              >
                {activeData && renderTabButton(activeData, true)}
              </div>

              {/* MOVING TABS VIEWPORT (Draggable & Continuous Train) */}
              <div
                ref={viewportRef}
                className="tabs-viewport"
                onMouseDown={handleMouseDown}
                onMouseMove={handleMouseMove}
                onMouseUp={handleMouseUpOrLeave}
                onMouseLeave={handleMouseUpOrLeave}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
                onMouseEnter={pauseInteraction}
              >
                <div
                  className="tabs-track"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "nowrap",
                    alignItems: "stretch",
                    width: "max-content",
                  }}
                >
                  {renderInactiveItems.map((tab, idx) => (
                    <React.Fragment key={`${tab.id}-${idx}`}>
                      {renderTabButton(tab, false, () => handleTabClick(tab))}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </div>




            {activeData && (
              <div className="industry-details-panel" key={activeData.id}>
                <div className="row align-items-center">
                  <div className="col-lg-6 col-md-12 col-12 info-side">
                    <h3 className="industry-details-title">{activeData.title}</h3>
                    <p className="industry-details-desc">{activeData.description}</p>
                    <div className="industry-details-grid">
                      {activeData.points.map((point, idx) => (
                        <div key={idx} className="industry-details-item">
                          <span className="details-check-circle" style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
                            {renderIcon(point.icon, 10)}
                          </span>
                          <span className="details-item-text">{point.title}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12 col-12 visual-side mt-4 mt-lg-0">
                    <div className={`industry-visual-wrapper ${activeData.image?.includes('portrait') ? 'portrait-mode' : ''}`}>
                      {activeData.image && (
                        <Image
                          src={activeData.image}
                          alt={activeData.title}
                          fill
                          sizes="(max-width: 480px) 420px, (max-width: 768px) 580px, (max-width: 991px) 720px, 600px"
                          quality={75}
                          loading="lazy"
                          className="industry-visual-image"
                          style={{ objectFit: "fill" }}
                        />
                      )}
                      <div className="industry-visual-glow"></div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </section>
  );
}

